import React from 'react';
import {Doughnut} from 'react-chartjs-2';
import {StatusChartProps} from "../../../../entity/props/chart/status-chart-props";
import {observer} from "mobx-react-lite";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import Grid from "@mui/material/Grid2";
import {Card, CardContent, List, ListItem, Typography} from "@mui/material";
import {ChartStatus} from "../../../../entity/resource/chart-status";
import {ChartTitle} from "../../../../entity/enums/chart-title";
import StatusWidget from "../widget/StatusWidget";

import '../../../../assets/css/style.css';
import '../../../../assets/css/chart/status-chart.css';

const StatusChart = (props: StatusChartProps): JSX.Element => {
    ChartJS.register(ArcElement, Tooltip, Legend);

    const orderData = props.data?.datasets.length > 0 ? props.data?.datasets[0].data : [];
    const isEmptyData = orderData.every((value: number) => value === 0) ?? false;
    const options = {
        ...props.options,
        cutout: '70%',
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: !isEmptyData,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                titleColor: '#ffffff',
                bodyColor: '#ffffff',
                bodyFont: {
                    size: 0,
                    family: 'Arial',
                },
                displayColors: false,
                callbacks: {
                    title: (tooltipItems: any) => {
                        const label = tooltipItems[0].label;
                        const value = tooltipItems[0].raw;
                        return `${value} ${label}`;
                    },
                    body: () => {
                        return '';
                    }
                },
            },
        },
        responsive: true,
        animation: {
            duration: 500,
            easing: "easeOutQuad",
        },
        hover: {
            mode: 'nearest',
            intersect: true,
            onHover: (event: any, chartElements: any[]) => {
                if (chartElements.length > 0) {
                    event.native.target.style.cursor = 'pointer';
                }
            },
        }
    }
    const placeholderData = {
        labels: ["No Data"],
        datasets: [
            {
                data: [1],
                backgroundColor: ["#d3d3d3"],
                borderColor: ["#a9a9a9"],
                borderWidth: 0
            }
        ]
    };

    const renderChartDetail = (chartStatus: ChartStatus): JSX.Element => {
        return (
            <ListItem key={chartStatus.status} className={'chart-detail-list-item'}>
                <Typography
                    id={`${chartStatus.status}-count`}
                    className={
                        chartStatus.status === ChartTitle.OPEN_ORDERS
                            ? 'chart-count open'
                            : chartStatus.status === ChartTitle.PENDING_REVIEW_ORDERS
                                ? 'chart-count pending-review'
                                : chartStatus.status === ChartTitle.PENDING_APPROVAL_ORDERS
                                    ? 'chart-count pending-approve'
                                    : chartStatus.status === ChartTitle.ON_HOLD_ORDERS
                                        ? 'chart-count on-hold'
                                        : 'chart-count completed'}>
                    {chartStatus.count}
                </Typography>
                <StatusWidget status={chartStatus.status}/>
            </ListItem>
        );
    }

    return (
        <Card elevation={0} className='chart-card'>
            <CardContent className='chart-card-content'>
                <Grid container direction='column'>
                    <Grid>
                        <Typography variant={'h5'} className={'chart-title'}>Files By Status</Typography>
                    </Grid>
                    <Grid className='chart-ui'>
                        <Doughnut data={isEmptyData ? placeholderData : props.data} options={options}/>
                    </Grid>
                </Grid>
                <List className={'chart-detail-list'}>
                    {
                        props.status.map(renderChartDetail)
                    }
                </List>
            </CardContent>
        </Card>
    );
}

export default observer(StatusChart);
